export function ArchiveSearchBar({
    years,
    onChangeSelect,
    submitHandler,
    serachInput,
    setSearchInput }) {
    return (
        <div className='ArchiveSearchBar'>
            <div className='selectYear'>
                <span>Տարեթիվը</span>

                <select onChange={onChangeSelect}>
                    {
                        years.map(elem => <option value={elem.year} key={elem._id}>
                            {elem.year} թ.
                        </option>)
                    }
                </select>
            </div>

            <form className='search-container' onSubmit={submitHandler}>
                <input
                    type='text'
                    value={serachInput}
                    placeholder='Որոնում...'
                    onChange={e => setSearchInput(e.target.value)}
                />
                
                <input type='submit' value='Որոնել' />
            </form>
        </div>
    )
}
